module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABSSURBVHgB7dexCYAADATA4ASO4Ajuv4wj6AYxhaUWgkTEO/g63z2JAOB7MnOqrNlnqcxnXYaLjmNliz7d9wD+6ViEliXpZkkA7kg/yev3AHjKDtLELxtdQUVeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-alt-1.png
// module id = z4/l
// module chunks = 1